// generated by genversion
export var version = '3.5.1';
//# sourceMappingURL=version.js.map